/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';

// actions
import {
    getClientEmbedsData,
    getLabels,
    createLabel,
    updateLabel,
    deleteLabel
} from 'state/actions/embedsState/embeds_status';
import { displayModal } from '@insticator/insticator-ui'; // iui-utils

// component
import LabelsManagementDropdown from 'material/embeds/controlbar/labelsmanagementdropdown/labelsmanagementdropdown';



/* ========== ~~~~~~~~~~ LABELS MANAGEMENT DROPDOWN : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    labels: embedsState.embedsStatus.labels
});

// map actions
const mapDispatchToProps = dispatch => ({
    getLabels: accountUUID => dispatch(getLabels(accountUUID)),
    createLabel: (accountUUID, labelName) => dispatch(createLabel(accountUUID, labelName)),
    updateLabel: (labelUUID, labelName) => dispatch(updateLabel(labelUUID, labelName)),
    deleteLabel: labelUUID => dispatch(deleteLabel(labelUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LabelsManagementDropdown);
